<template>
  <!-- Reusable categorical value picker: toggle which values of a header are
       shown. Used by both the dataset and farm/block filter UIs. v-model
       compatible (value = selected array, emits 'input'). -->
  <div class="category-chips">
    <div class="cc-actions">
      <button type="button" class="cc-link" @click="selectAll">Select all</button>
      <button type="button" class="cc-link" :disabled="!value.length" @click="clear">Clear</button>
      <span class="cc-count">{{ value.length }}/{{ options.length }} shown</span>
    </div>
    <div class="cc-list">
      <button
        v-for="opt in options"
        :key="opt"
        type="button"
        class="cc-chip"
        :class="{ active: value.indexOf(opt) !== -1 }"
        @click="toggle(opt)"
      >
        <i :class="value.indexOf(opt) !== -1 ? 'fas fa-check-square' : 'far fa-square'"></i> {{ opt }}
      </button>
      <p v-if="!options.length" class="cc-empty">No values found for this header.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryChips',
  props: {
    options: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] }
  },
  methods: {
    toggle (opt) {
      const next = this.value.indexOf(opt) !== -1
        ? this.value.filter(v => v !== opt)
        : this.value.concat([opt])
      this.$emit('input', next)
    },
    selectAll () { this.$emit('input', this.options.slice()) },
    clear () { this.$emit('input', []) }
  }
}
</script>

<style scoped>
.category-chips { margin-top: 8px; }
.cc-actions { display: flex; align-items: center; gap: 12px; font-size: 12.5px; margin-bottom: 6px; }
.cc-link { background: none; border: none; color: #056839; cursor: pointer; padding: 0; font-size: 12.5px; }
.cc-link:disabled { color: #adb5bd; cursor: not-allowed; }
.cc-link:hover:not(:disabled) { text-decoration: underline; }
.cc-count { margin-left: auto; color: #6c757d; }
.cc-list { display: flex; flex-wrap: wrap; gap: 6px; max-height: 220px; overflow-y: auto; }
.cc-chip {
  background: #fff; border: 1px solid #ced4da; border-radius: 14px;
  padding: 4px 11px; font-size: 13px; color: #212529; cursor: pointer;
}
.cc-chip:hover { background: #f1f3f5; }
.cc-chip.active { background: #056839; border-color: #056839; color: #fff; }
.cc-chip i { margin-right: 3px; }
.cc-empty { color: #6c757d; font-size: 13px; margin: 4px 0; }
</style>
